import { gql } from '@apollo/client';

export const MUTATION_REQUEST_VEHICLE = gql`
  mutation RequestVehicle(
    $sku: String!
    $dealerId: String!
    $formData: RequestVehicleInput
    $configuratorId: String
  ) {
    requestVehicle(
      sku: $sku
      dealerId: $dealerId
      formData: $formData
      configuratorId: $configuratorId
    )
  }
`;

export const MUTATION_CONTACT_DEALER = gql`
  mutation ContactDealer(
    $vehicleId: String!
    $dealerId: String!
    $formData: ContactDealerInput
    $configuratorId: String
  ) {
    contactDealer(
      vehicleId: $vehicleId
      dealerId: $dealerId
      formData: $formData
      configuratorId: $configuratorId
    )
  }
`;

export const MUTATION_TRADE_IN_CONTACT_DEALER = gql`
  mutation TradeInContactDealer(
    $garageVehicleId: String!
    $dealerId: String
    $formData: ContactTradeInInput
  ) {
    tradeInContactDealer(
      garageVehicleId: $garageVehicleId
      dealerId: $dealerId
      formData: $formData
    )
  }
`;

export const MUTATION_TEST_DRIVE_BOOKING = gql`
  mutation RequestTestDrive(
    $vehicleId: String!
    $dealerId: String!
    $formData: RequestTestDriveInput
    $configuratorId: String
  ) {
    requestTestDrive(
      vehicleId: $vehicleId
      dealerId: $dealerId
      formData: $formData
      configuratorId: $configuratorId
    )
  }
`;

export const MUTATION_CALCULATE_LEASING = gql`
  mutation CalculateLeasing(
    $vehicleId: String
    $dealerId: String
    $carConfiguratorId: String
    $input: LeasingCalculationInput
  ) {
    calculateLeasing(
      vehicleId: $vehicleId
      dealerId: $dealerId
      configuratorId: $carConfiguratorId
      input: $input
    ) {
      monthlyInstallment
      summary
    }
  }
`;

export const MUTATION_CALCULATE_LOAN = gql`
  mutation CalculateLoan(
    $vehicleId: String
    $dealerId: String
    $carConfiguratorId: String
    $input: LoanCalculationInput
  ) {
    calculateLoan(
      vehicleId: $vehicleId
      dealerId: $dealerId
      configuratorId: $carConfiguratorId
      input: $input
    ) {
      monthlyInstallment
      summary
      finalInstallment
    }
  }
`;

export const MUTATION_PREAPPROVAL_FORM = gql`
  mutation CalculatePreApproval($vehicleId: String, $input: PreApprovalInput) {
    calculatePreApproval(vehicleId: $vehicleId, input: $input) {
      isPreApproved
      message
    }
  }
`;
